export const SEARCH_USER_DIALOG = 'SEARCH_USER_DIALOG';
export const SEARCH_COURSE_DIALOG = 'SEARCH_COURSE_DIALOG';
export const CREATE_COURSE_DIALOG = 'CREATE_COURSE_DIALOG';
export const CREATE_MODULE_DIALOG = 'CREATE_MODULE_DIALOG';
export const CREATE_REPORT_DIALOG = 'CREATE_REPORT_DIALOG';
export const CREATE_SUBJECT_DIALOG = 'CREATE_SUBJECT_DIALOG';
export const CREATE_CLASS_DIALOG = 'CREATE_CLASS_DIALOG';
export const UPDATE_MODULE_DIALOG = 'UPDATE_MODULE_DIALOG';
export const UPDATE_SUBJECT_DIALOG = 'UPDATE_SUBJECT_DIALOG';
export const UPDATE_CLASS_DIALOG = 'UPDATE_CLASS_DIALOG';
export const ADD_VIDEO_DIALOG = 'ADD_VIDEO_DIALOG';
export const ADD_URL_DIALOG = 'ADD_URL_DIALOG';
export const USER_DIALOG = 'USER_DIALOG';
export const ME_USER_DIALOG = 'ME_USER_DIALOG';
export const ME_PASSWORD_DIALOG = 'ME_PASSWORD_DIALOG';
export const CREATE_USER_DIALOG = 'CREATE_USER_DIALOG';
export const JOIN_USER_DIALOG = 'JOIN_USER_DIALOG';
export const CREATE_TEMPLATE_DIALOG = 'CREATE_TEMPLATE_DIALOG';
export const UPDATE_TEMPLATE_DIALOG = 'UPDATE_TEMPLATE_DIALOG';
export const LINK_DIALOG = 'LINK_DIALOG';
export const CREATE_SUBSCRIPTION_DIALOG = 'CREATE_SUBSCRIPTION_DIALOG';
export const EDIT_SUBSCRIPTION_DIALOG = 'EDIT_SUBSCRIPTION_DIALOG';
export const CREATE_SECUENCE_DIALOG = 'CREATE_SECUENCE_DIALOG';
export const UPDATE_SECUENCE_DIALOG = 'UPDATE_SECUENCE_DIALOG';
export const SEARCH_FORUM_USER_DIALOG = 'SEARCH_FORUM_USER_DIALOG';
export const CALCULATOR_TUTORIAL_DIALOG = 'CALCULATOR_TUTORIAL_DIALOG';
export const DIAGNOSTIC_QUESTIONS_TUTORIAL_DIALOG = 'DIAGNOSTIC_QUESTIONS_TUTORIAL_DIALOG';
export const TRADING_METRICS_TUTORIAL_DIALOG = 'TRADING_METRICS_TUTORIAL_DIALOG';
export const FINANCIAL_METRICS_TUTORIAL_DIALOG = 'FINANCIAL_METRICS_TUTORIAL_DIALOG';
export const LIQUID_ASSETS_TUTORIAL_DIALOG = 'LIQUID_ASSETS_TUTORIAL_DIALOG';
export const REAL_ESTATE_TUTORIAL_DIALOG = 'REAL_ESTATE_TUTORIAL_DIALOG';
export const FINANCIAL_GOALS_TUTORIAL_DIALOG = 'FINANCIAL_GOALS_TUTORIAL_DIALOG';
export const CREATE_EVENT_DIALOG = 'CREATE_EVENT_DIALOG';
export const UPDATE_EVENT_DIALOG = 'UPDATE_EVENT_DIALOG';
export const CALENDAR_EVENT_DIALOG = 'CALENDAR_EVENT_DIALOG';
export const CREATE_ALLIANCE_DIALOG = 'CREATE_ALLIANCE_DIALOG';
